import * as components from '../';

export default {
    name: 'content_sections',
    components:components,
    props:{
        sections:{type:Array,required:true},
    },
    created(){
        // console.log('sections created');
    }
}


// WEBPACK FOOTER //
// ./src/components/content/sections/sections.js